import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSupabase } from '../../context/SupabaseContext';
import { resolveGrowthAccess } from '../../services/growthService';
import { LoadingState } from '../common/LoadingState';

export function GrowthReadOnlyRoute({ children }: { children: ReactNode }) {
  const { salonId } = useSupabase();
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let active = true;

    const resolve = async () => {
      const access = await resolveGrowthAccess(salonId);
      if (active) {
        setAllowed(access.canViewGrowth && access.showGrowthInNavigation);
      }
    };

    void resolve();
    return () => {
      active = false;
    };
  }, [salonId]);

  if (allowed === null) {
    return <LoadingState className="min-h-[40vh]" />;
  }

  return allowed ? <>{children}</> : <Navigate to="/" replace />;
}